import React, { useEffect, useState } from "react";
const contentData = require("../data/data.json");

const AppContext = React.createContext({
  start: false,
  step: 0,
  category: "",
  division: "",
  content: {},
  question: 0,
  isVerified: false,
  finish: false,
  hasError: false,
  message: "",
  handleSkipIntro: () => {},
  handleNextStep: () => {},
  handlePrevStep: () => {},
  handleSelectDivison: () => {},
  handleAnswer: () => {},
  handleBatchAnswer: () => {},
  handleRating: () => {},
  handleSubmit: () => {},
  handleVerifyCaptcha: () => {},
  handleErrorState: () => {},
});

const retrieveStoredData = () => {
  const res = localStorage.getItem("data");
  return JSON.parse(res) || {};
};

export const AppContextProvider = (props) => {
  const storedData = retrieveStoredData();
  const [start, setStart] = useState(storedData.start || false);
  const [step, setStep] = useState(+storedData.step);
  const [category, setCategory] = useState(storedData.category);
  const [division, setDivision] = useState(storedData.division);
  const [question, setQuestion] = useState(storedData.question);
  const [finish, setFinish] = useState(storedData.finish || false);
  const [content, setContent] = useState({});
  const [isVerified, setIsVerified] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [message, setMessage] = useState("");
  const [token, setToken] = useState(null);
  const answers = storedData.answers || [];

  const handleSkipIntro = ({ name, phone, loc }) => {
    setStart(true);
    setStep(1);
    localStorage.setItem(
      "data",
      JSON.stringify({ start: true, name, phone, loc, step: 1 })
    );
  };

  const handleNextStep = (step, category) => {
    setStep(+step);
    setCategory(category);
    localStorage.setItem(
      "data",
      JSON.stringify({ ...storedData, step, category })
    );
  };

  const handlePrevStep = () => {
    if (step === 2) {
      const { category, ...newStoredData } = storedData;
      setStep((prevState) => prevState - 1);
      localStorage.setItem(
        "data",
        JSON.stringify({ ...newStoredData, step: 1 })
      );
    } else if (step === 3) {
      if (category === "ask") {
        const { category, ...newStoredData } = storedData;
        setStep(1);
        localStorage.setItem(
          "data",
          JSON.stringify({ ...newStoredData, step: 1 })
        );
      } else {
        const { question: q, totalQuestions: tq } = retrieveStoredData();

        if (+q === 0) {
          const {
            division,
            question,
            totalQuestions,
            answers,
            ...newStoredData
          } = storedData;
          setStep((prevState) => prevState - 1);
          setDivision("");
          localStorage.setItem(
            "data",
            JSON.stringify({ ...newStoredData, step: 2 })
          );
        } else {
          let newTotal = 0;
          if (tq === q) {
            storedData.answers.pop();
            newTotal = tq - 1;
          } else {
            switch (q.toString()) {
              case "1":
                storedData.answers.splice(0);
                newTotal = 0;
                break;
              case "2":
                storedData.answers.splice(2);
                newTotal = 2;
                break;
              case "3":
                storedData.answers.splice(8);
                newTotal = 8;
                break;
              case "4":
                storedData.answers.splice(11);
                newTotal = 11;
                break;
              case "5":
                storedData.answers.splice(14);
                newTotal = 14;
                break;
              default:
                newTotal = 17;
            }
          }

          setQuestion((prevState) => prevState - 1);
          localStorage.setItem(
            "data",
            JSON.stringify({
              ...storedData,
              question: q - 1,
              totalQuestions: newTotal,
            })
          );
        }
      }
    }
  };

  const handleSelectDivison = (step, division) => {
    setStep(+step);
    setDivision(division);
    setQuestion(0);
    localStorage.setItem(
      "data",
      JSON.stringify({
        ...storedData,
        step,
        division,
        question: 0,
        totalQuestions: 0,
      })
    );
  };

  const handleAnswer = (answer) => {
    answers.push({ question, answer });
    storedData.answers = answers;
    storedData.totalQuestions = retrieveStoredData()["totalQuestions"] + 1;
    localStorage.setItem("data", JSON.stringify(storedData));

    setQuestion((prevState) => {
      let value = +prevState + 1;
      localStorage.setItem(
        "data",
        JSON.stringify({
          ...storedData,
          question: value,
        })
      );
      return value;
    });
  };

  const handleBatchAnswer = (batchAnswers) => {
    batchAnswers.forEach((x) => {
      answers.push({ question, answer: x });
      storedData.answers = answers;
      storedData.totalQuestions = retrieveStoredData()["totalQuestions"] + 1;
      localStorage.setItem("data", JSON.stringify(storedData));
    });

    setQuestion((prevState) => {
      let value = +prevState + 1;
      localStorage.setItem(
        "data",
        JSON.stringify({ ...storedData, question: value })
      );
      return value;
    });
  };

  const handleRating = (answer, next = true) => {
    if (next) {
      setQuestion((prevState) => {
        let value = +prevState + 1;
        localStorage.setItem(
          "data",
          JSON.stringify({
            ...storedData,
            question: value,
            rating: +answer,
          })
        );
        return value;
      });
    } else {
      localStorage.setItem(
        "data",
        JSON.stringify({
          ...storedData,
          rating: +answer,
        })
      );
    }
  };

  const handleVerifyCaptcha = (response) => {
    if (response) {
      setToken(response);
      setIsVerified(true);
    } else {
      setHasError(true);
      setMessage("Captcha verification failed.");
    }
  };

  const handleSubmit = ({ newName, newPhone, extra, newRating }) => {
    const name = newName ? newName : storedData.name;
    const phone = newPhone ? newPhone : storedData.phone;
    const loc = storedData.loc || 1;
    const rating = newRating ? newRating : storedData.rating || 0;

    if (isVerified) {
      if (extra) {
        localStorage.setItem(
          "data",
          JSON.stringify({ ...storedData, name, phone, extra })
        );
      }

      fetch("https://103.160.12.43/api/suara-pelanggan/create.php", {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        // headers: {
        //   "Content-Type": "application/json",
        // },
        body: JSON.stringify({
          category,
          division,
          name,
          phone,
          loc,
          answers,
          rating,
          extra,
          token,
        }),
      })
        .then((resp) => resp.json())
        .then((data) => {
          if (!data.error) {
            setFinish(true);
            localStorage.setItem(
              "data",
              JSON.stringify({ ...storedData, finish: true })
            );
          } else {
            alert(data.message);
          }
        })
        .catch((err) => console.error("Error: ", err));
    } else {
      setHasError(true);
      setMessage("Captcha verification failed.");
    }
  };

  const handleErrorState = (errorState) => {
    setHasError(errorState);
  };

  useEffect(() => {
    if (finish) {
      setStart(false);
      setCategory("");
      setDivision("");
      setFinish(false);
      localStorage.clear();
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (category) {
      let res;
      res = contentData.find((o) => o.category === category);

      if (category === "satisfy" && division && !finish) {
        res = res.divisions.find((o) => o.division === division);
      }
      setContent(res);
    }
  }, [category, division, finish]);

  const contextValue = {
    start,
    step,
    category,
    division,
    content,
    question,
    isVerified,
    finish,
    hasError,
    message,
    handleSkipIntro,
    handleNextStep,
    handlePrevStep,
    handleSelectDivison,
    handleAnswer,
    handleBatchAnswer,
    handleRating,
    handleSubmit,
    handleVerifyCaptcha,
    handleErrorState,
  };

  return (
    <AppContext.Provider value={contextValue}>
      {props.children}
    </AppContext.Provider>
  );
};

export default AppContext;
